export const NAME = 'ProdejZbozi';
